//======> Docementation <== ====//
registerBlockType("tornado/aboutus-section2", {
  title: __("About Us Secound Section", "tornado"),
  description: __("عن الشركة الجزء الثاني", "tornado"),
  icon: "feedback",
  category: "tornado",
  keywords: ["tornado", "section"],
  supports: {
    align: ["full", "wide"],
  },
  attributes: {
    BGImage: {
      type: "string",
      default: null,
    },
    featImgAbout: {
      type: "string",
      default: null,
    },
    featImgAbout2: {
      type: "string",
      default: null,
    },
    // featImgAbout3: {
    //   type: "string",
    //   default: null,
    // },
    head: {
      type: "string",
      default: "رؤيتنا",
    },
    head2: {
      type: "string",
      default: "رسالتنا",
    },
    // head3: {
    //   type: "string",
    //   default: "اهدافنا",
    // },
    body: {
      type: "string",
      default:
        " هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى      ",
    },
    body2: {
      type: "string",
      default:
        " هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى      ",
    },
    // body3: {
    //   type: "string",
    //   default : " هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى      "

    // },
  },
  //==== Editing Mode ====//
  edit: (props) => {
    //==== Block Data ====//
    const { attributes, setAttributes } = props;
    props.setAttributes({ align: "full" });
    function onChangeBackGround(newBG) {
      setAttributes({ BGImage: newBG.sizes.full.url });
    }
    function onChangefeatImg(newIMG) {
      setAttributes({ featImgAbout: newIMG.sizes.full.url });
    }
    function onChangefeatImg2(newIMG2) {
      setAttributes({ featImgAbout2: newIMG2.sizes.full.url });
    }
    // function onChangefeatImg3(newIMG3) {
    //   setAttributes({ featImgAbout3: newIMG3.sizes.full.url });
    // }
    const set_head = (head) => {
      setAttributes({ head });
    };
    const set_head2 = (head2) => {
      setAttributes({ head2 });
    };
    // const set_head3 = (head3) => {
    //   setAttributes({ head3 });
    // };

    const set_body1 = (body) => {
      setAttributes({ body });
    };
    const set_body2 = (body2) => {
      setAttributes({ body2 });
    };
    // const set_body3 = (body3) => {
    //   setAttributes({ body3 });
    // };

    return (
      <Panel>
        <InspectorControls style={{ marginBottom: "40px" }}>
          <PanelBody>
            <p>Select The Image For Background !</p>
            <MediaUpload
              onSelect={onChangeBackGround}
              value={attributes.BGImage}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image!{" "}
                </IconButton>
              )}
            />

            <p>Select The Image for first feature !</p>
            <MediaUpload
              onSelect={onChangefeatImg}
              value={attributes.featImgAbout}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image!{" "}
                </IconButton>
              )}
            />
            <p>Select The Image for secound feature !</p>
            <MediaUpload
              onSelect={onChangefeatImg2}
              value={attributes.featImgAbout2}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image!{" "}
                </IconButton>
              )}
            />
            {/* <p>Select The Image for third feature !</p>
            <MediaUpload
              onSelect={onChangefeatImg3}
              value={attributes.featImgAbout3}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image!{" "}
                </IconButton>
              )}
            /> */}
          </PanelBody>
        </InspectorControls>

        <div
          class="section-small secondary-bg about-blocks"
          data-src={attributes.BGImage}
        >
          <div class="container tx-align-center">
            <div class="row">
              <div class="icon-block about-block col-12 col-m-6 col-l-6">
                <i class="icon">
                  <img src={attributes.featImgAbout} alt="" />
                </i>
                <RichText
                  tagName="h3"
                  value={attributes.head}
                  onChange={set_head}
                />
                <RichText
                  tagName="p"
                  value={attributes.body}
                  onChange={set_body1}
                />
              </div>
              <div class="icon-block about-block col-12 col-m-6 col-l-6">
                <i class="icon">
                  <img src={attributes.featImgAbout2} alt="" />
                </i>
                <RichText
                  tagName="h3"
                  value={attributes.head2}
                  onChange={set_head2}
                />
                <RichText
                  tagName="p"
                  value={attributes.body2}
                  onChange={set_body2}
                />
              </div>
              {/* <div class="icon-block about-block col-12 col-m-6 col-l-4">
                <i class="icon">
                  <img src={attributes.featImgAbout3} alt="" />
                </i>
                <RichText
                  tagName="h3"
                  value={attributes.head3}
                  onChange={set_head3}
                />
                <RichText
                  tagName="p"
                  value={attributes.body3}
                  onChange={set_body3}
                />
              </div> */}
            </div>
          </div>
        </div>
      </Panel>
    );
  },
  //==== Puplish Mode ====//
  save: (props) => {
    const { attributes } = props;
    // <!-- About Us -->
    return (
      <div
        class="section-small secondary-bg about-blocks"
        data-src={attributes.BGImage}
      >
        <div class="container tx-align-center">
          <div class="row">
            <div class="icon-block about-block col-12 col-m-6 col-l-6">
              <i class="icon">
                <img src={attributes.featImgAbout} alt="" />
              </i>
              <h3>{attributes.head}</h3>
              <p>{attributes.body}</p>
            </div>
            <div class="icon-block about-block col-12 col-m-6 col-l-6">
              <i class="icon">
                <img src={attributes.featImgAbout2} alt="" />
              </i>
              <h3>{attributes.head2}</h3>
              <p>{attributes.body2}</p>
            </div>
            {/* <div class="icon-block about-block col-12 col-m-6 col-l-4">
              <i class="icon">
                <img src={attributes.featImgAbout3} alt="" />
              </i>
              <h3>{attributes.head3}</h3>
              <p>{attributes.body3}</p>
            </div> */}
          </div>
        </div>
      </div>
    );
    // <!-- // About Us -->
  },
});
